import { FoundationsButton } from '../../GenericComponents/button'
import { FoundationsInput } from '../../GenericComponents/input'
import { FoundationsConstants } from '../../FoundationsConstants'
import { getBaseUrl, FoundationsRequest, handleHardReload } from '../../Utils'
import { useEffect, useState } from 'react'
import SignInBanner from '../../Components/SignInBanner.tsx/SignInBanner'
import Image from '../../GenericComponents/Image/Image'
import { appSettingsType } from '../../Types/appSettings'
import { useForm } from 'react-hook-form'
import { FoundationsForm } from '../../GenericComponents/form'
import { FormValidation } from '../../FormValidationsRules'
import { FoundationsAlert } from '../../GenericComponents/alert'
// import { useNavigate } from 'react-router-dom'
import { FoundationsEnums } from '../../FoundationsEnums'
import { ForgotPasswordPage } from '../forgotPassword/forgotPassword'
import { ClientJS } from 'clientjs'
import {
    usePerformPIVSignInMutation,
    usePerformSignInMutation,
    useSetBrowserDetailsMutation,
} from '../../Redux/SignIn/signinSlice'
import { handleSSOSignIn } from '../../Utils'

declare let window: any

// TODO UnicornApp and navigate should be declared in a more universal location
const UnicornApp = window.unicornInstance as any

export function SignInPage() {
    const [appSettings, setAppSettings] = useState({} as appSettingsType)

    UnicornApp.getCurrentUserFromAPI()
        .then(function (me: any) {
            if (me?.get('AccountInfo')) {
                UnicornApp.redirectToHome()
            } else {
                const cookies = UnicornApp.getAllCookies()
                for (const cookie in cookies) {
                    if (
                        !(
                            cookie == FoundationsConstants.TOKEN_STR ||
                            cookie == FoundationsConstants.TOKEN_EXP_STR
                        )
                    )
                        UnicornApp.setCookie(cookie, false, -15)
                }
            }
        })
        .fail(() => {
            const cookies = UnicornApp.getAllCookies()
            for (const cookie in cookies) {
                if (
                    !(
                        cookie == FoundationsConstants.TOKEN_STR ||
                        cookie == FoundationsConstants.TOKEN_EXP_STR
                    )
                )
                    UnicornApp.setCookie(cookie, false, -15)
            }
        })

    useEffect(() => {
        UnicornApp.getAppSettings().then((appSettings: any) => {
            setAppSettings(appSettings.toJSON())
        })
    }, [])

    return (
        <>
            <div id="signin_page" className="row mt-0 no-gutters">
                <div id="signin_form_container" className="login-box-shadow row pt-4 px-4">
                    <div className="col-12 px-4" id="system_banner_signin">
                        {appSettings.signInBanner?.length > 0 ? (
                            <SignInBanner
                                text={appSettings.signInBanner}
                                isBannerGlow={
                                    appSettings.signInBanner ==
                                    FoundationsConstants.BANNER_UNINITIALIZED_TEXT
                                }
                                show={true}
                                classes={''}
                            />
                        ) : (
                            <></>
                        )}
                    </div>
                    <div className="col-12 p-0">
                        <div className="mb-auto mt-0 mx-auto w-90">
                            <a
                                className="header-logo mb-1 mx-auto d-block"
                                href="https://www.healthlevel.com"
                            >
                                {appSettings.logo && (
                                    <Image
                                        src={getBaseUrl() + appSettings.logo}
                                        id="signin_logo"
                                        alt="logo.png"
                                        title="Healthlevel"
                                        classes="header-logo-img"
                                    />
                                )}
                            </a>
                        </div>
                        <div className="col-12" id="signin_form_el">
                            <SignInForm
                                ssoEnabled={!!appSettings.SSOModel}
                                pivEnabled={appSettings.PIVEnabled}
                                siteName={appSettings.applicationName}
                                buildVersion={appSettings.buildVersion}
                            />
                        </div>
                        <div className="col-12 px-0 pb-3">
                            <div className="main-bottom-container mb-3">
                                {appSettings.signInCustomHelpSection?.custom_help_header.length >
                                0 ? (
                                    <>
                                        <div className="padding-top-small"></div>
                                        <div className="content">
                                            <div
                                                className="header"
                                                dangerouslySetInnerHTML={{
                                                    __html: appSettings.signInCustomHelpSection
                                                        ?.custom_help_header,
                                                }}
                                            ></div>
                                            <div>
                                                <span
                                                    dangerouslySetInnerHTML={{
                                                        __html: appSettings.signInCustomHelpSection
                                                            ?.custom_help_line_1,
                                                    }}
                                                ></span>
                                                <br />
                                                <span
                                                    dangerouslySetInnerHTML={{
                                                        __html: appSettings.signInCustomHelpSection
                                                            ?.custom_help_line_2,
                                                    }}
                                                ></span>
                                            </div>
                                        </div>
                                    </>
                                ) : (
                                    <></>
                                )}
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </>
    )
}
interface SignInformProps {
    ssoEnabled: boolean,
    pivEnabled: boolean
    siteName: string
    buildVersion: string | undefined
}

function SignInForm(props: SignInformProps) {
    // const navigate = useNavigate()
    const {
        register,
        handleSubmit,
        formState: { errors },
    } = useForm()
    const [signInLoading, setSignInLoading] = useState(false)
    const [openIdLoading, setOpenIdLoading] = useState(false)
    const [userEmail, setUserEmail] = useState('')
    const [userPassword, setUserPassword] = useState('')
    const [pageError, setPageError] = useState('')
    const [requestSent, setRequestSent] = useState(false)
    const [performSignIn] = usePerformSignInMutation()
    const [performPIVSignIn] = usePerformPIVSignInMutation()
    const [setBrowserDetails] = useSetBrowserDetailsMutation()
    // TODO add i18n support again
     useEffect(() => {
        UnicornApp.getAppSettings().then((appSettings: any) => {
            setAppSettings(appSettings.toJSON())
        })
    }, [])
    const [appSettings, setAppSettings] = useState({} as appSettingsType)

    const onClickSSOSigninButton = () => {
        handleSSOSignIn({
            setPageError,
            setOpenIdLoading,
            setRequestSent
        });
    };
    const handlePivSignIn = async () => {
        setPageError('');
        setSignInLoading(true);
        setRequestSent(true);
        let retried = false;
        async function pivSignInRequest(url: string) {
            const response = await fetch(url, {
                method: "GET",
                credentials: "include",
            });
            if (response.ok) {
                const data = await response.json();
                if(data.statusCode && data.statusCode >= 400 && data.statusCode < 500){
                    setPageError(data.statusMessage)
                    return;
                }
                performPIVSignIn(data.data)
                    .then(({ data }) => handleSignInResponse(data))
                    .catch((request: { responseJSON: { hints: any; statusMessage: any } }) => {
                        setPageError(
                            request.responseJSON?.hints
                                ? request.responseJSON.hints
                                : request.responseJSON?.statusMessage
                        )
                    })
            } else if (response.status === 403 && !retried) {
                retried = true;
                // Try baseURL/PIVSignIn once
                const baseUrl = getBaseUrl().replace(/\/+$/, '') + '/API/v3/Account/PIVSignIn';
                await pivSignInRequest(baseUrl);
            } else {
                setPageError("PIV Authentication failed. Please try again.");
            }
        }
        try {
            const pivLoginUrl =
                (appSettings.PIVAppURL?.replace(/\/+$/, '') || '') +
                '/API/v3/Account/PIVSignIn';
            await pivSignInRequest(pivLoginUrl);
        } catch (error) {
            setPageError("Error: PIV Authentication failed. Please try again.");
        } finally {
            setSignInLoading(false);
            setRequestSent(false);
        }
    };


    // TODO add SSO login functionality
    // const onClickSSOSigninButton = () => {
    //     setPageError('')
    //     setOpenIdLoading(true)
    //     setRequestSent(true)
    //     FoundationsRequest('GET', {
    //         url: 'api/v3/account/SSOLogin',
    //         cache: false,
    //         // contentType: 'application/x-www-form-urlencoded; charset=UTF-8',
    //         success: function (response: { data: any } | null) {
    //             if (response != null) {
    //                 const authRequest = response.data
    //                 if (authRequest != null) {
    //                     const openIDURL =
    //                         authRequest.OpenIdLoginURL +
    //                         authRequest.OpenIdRedirectURL +
    //                         '&scope=' +
    //                         authRequest.scope +
    //                         '&client_id=' +
    //                         authRequest.client_id +
    //                         '&state=' +
    //                         authRequest.state
    //                     UnicornApp.setCookie(
    //                         FoundationsConstants.OPENID_STATE,
    //                         authRequest.state,
    //                         10
    //                     )
    //                     window.location.href = openIDURL
    //                 }
    //             }
    //         },
    //         error: function (
    //             request: { responseJSON: { hints: any; statusMessage: any } },
    //             err: any
    //         ) {
    //             setPageError(
    //                 request.responseJSON?.hints
    //                     ? request.responseJSON.hints
    //                     : request.responseJSON?.statusMessage
    //             )
    //             setOpenIdLoading(false)
    //             setRequestSent(false)
    //         },
    //     })
    // }

    const submitSignIn = () => {
        setPageError('')
        const requestUserInfo = {
            EmailAddress: userEmail,
            Password: UnicornApp.encryptData(userPassword),
        }
        setSignInLoading(true)
        setRequestSent(true)

        performSignIn(requestUserInfo)
            .then(({ data }) => handleSignInResponse(data))
            .catch((request: { responseJSON: { hints: any; statusMessage: any } }) => {
                setPageError(
                    request.responseJSON?.hints
                        ? request.responseJSON.hints
                        : request.responseJSON?.statusMessage
                )                    
            })
            .finally(() => {
                setSignInLoading(false)
                setRequestSent(false)
            })

        // FoundationsRequest('POST', {
        //     url: 'API/v3/Account/SignIn',
        //     cache: false,
        //     data: requestUserInfo,
        //     success: function (
        //         response: {
        //             data: {
        //                 MessageResults: any
        //                 data: any
        //             }
        //         } | null
        //     ) {
        //         if (response != null) {
        //             const resultData = response.data
        //             if (resultData != null) {
        //                 if (resultData.MessageResults.length > 0) {
        //                     for (let i = 0; i < resultData.MessageResults.length; i++) {
        //                         if (
        //                             resultData.MessageResults[i].HelpMessage ==
        //                             FoundationsEnums.Status.Success
        //                         ) {
        //                             UnicornApp.setHLUserCookies(response)
        //                             UnicornApp.getCurrentUserFromAPI(true).then(
        //                                 (me: { get: (arg0: string) => any }) => {
        //                                     UnicornApp.getAppSettings(true).then((_: any) => {
        //                                         UnicornApp.globals.authToken = response.data
        //                                         UnicornApp.previouselySignedInOrOut = true
        //                                         setTimeout(() => {
        //                                             UnicornApp.initSessionAndTokenThread()
        //                                         }, 5 * 1000)
        //                                         UnicornApp.startProxyCheckThread()
        //                                         const client = new ClientJS()
        //                                         const userBrowserDetails = {
        //                                             browserName: client.getBrowser(),
        //                                             OSName: client.getOS(),
        //                                             userAgent: client.getUserAgent(),
        //                                             userId: UnicornApp.getUserId(),
        //                                             isMobile: client.isMobile(),
        //                                             screenResolution: client.getCurrentResolution(),
        //                                             engine: client.getEngine(),
        //                                             browserVersion: client.getBrowserVersion(),
        //                                             browserMajorVersion:
        //                                                 client.getBrowserMajorVersion(),
        //                                             osVersion: client.getOSVersion(),
        //                                             fingerprint: client.getCustomFingerprint(
        //                                                 client.getUserAgent(),
        //                                                 client.getBrowser(),
        //                                                 client.isMobile() + '',
        //                                                 client.getScreenPrint(),
        //                                                 client.getEngine(),
        //                                                 client.getBrowserVersion(),
        //                                                 client.getBrowserMajorVersion(),
        //                                                 client.getOS(),
        //                                                 client.getOSVersion()
        //                                             ),
        //                                         }

        //                                         FoundationsRequest('POST', {
        //                                             url: 'api/v3/Account/BrowserDetails/',
        //                                             cache: false,
        //                                             data: userBrowserDetails,
        //                                             success: function () {},
        //                                         })
        //                                         const favWorkspace = me.get('UserFavWorkspace')
        //                                         if (
        //                                             UnicornApp.urlBeforeFailedAuth &&
        //                                             UnicornApp.urlBeforeFailedAuth != '#signin'
        //                                         ) {
        //                                             window.location.replace(
        //                                                 UnicornApp.urlBeforeFailedAuth.substring(0)
        //                                             )
        //                                             // navigate(
        //                                             //     UnicornApp.urlBeforeFailedAuth.substring(
        //                                             //         0
        //                                             //     ),
        //                                             //     {
        //                                             //         state: {
        //                                             //             /* Pass state here when no longer user Uniorn */
        //                                             //         },
        //                                             //     }
        //                                             // )
        //                                         } else {
        //                                             UnicornApp.redirectToHome('', favWorkspace)
        //                                         }
        //                                     })
        //                                 }
        //                             )
        //                         } else {
        //                             setPageError(response.data.data)
        //                         }
        //                     }
        //                 } else {
        //                     UnicornApp.toastr('error', 'Something went wrong!')
        //                     setPageError(resultData.data)
        //                 }
        //             }
        //         }
        //         setSignInLoading(false)
        //         setRequestSent(false)
        //     },
        //     error: function (
        //         request: { responseJSON: { hints: any; statusMessage: any } },
        //         err: any
        //     ) {
        //         setPageError(
        //             request.responseJSON?.hints
        //                 ? request.responseJSON.hints
        //                 : request.responseJSON?.statusMessage
        //         )
        //         setSignInLoading(false)
        //         setRequestSent(false)
        //     },
        // })
    }
    const handleSignInResponse = (data: any) => {
                if (data != null) {
                    const resultData = data.data
                    if (data.statusCode >= 500 && data.statusCode < 600) {
                        handleHardReload(window.location.href)
                    } else if (resultData != null) {
                         if(resultData.userData!=null && resultData.userData.Id ==-99){
                                    // New user registration through OpenID
                                    // New user will always have Id = -99
                                    // console.log(response);
                                    // console.log(response.data.EmailAddress);
                                    UnicornApp.setCookie(FoundationsConstants.NEW_USER,JSON.stringify(resultData.userData), 15);
                                    window.location.href = window.baseURL +"/ux/index.html#register?"+FoundationsConstants.isSSO+"=1";
                        
                                    // Call Registration page to fill up registration page with FirstName,LastName,Full Name and Email Address.
                                    // Please disable these fields on the forms.
                                    // Password fields are going to be optional for OpenID form
                                    //AccountApiDTO_User class have one more member authSource. Please set this to Enum Helper.Authentication.OpenID
                                    
                         }
                        else {
                            if (resultData.MessageResults.length > 0) {
                                for (let i = 0; i < resultData.MessageResults.length; i++) {
                                if (
                                    resultData.MessageResults[i].HelpMessage ==
                                    FoundationsEnums.Status.Success
                                ) {
                                    console.log("into sign in success")
                                  
                                    UnicornApp.setHLUserCookies(resultData)
                                    UnicornApp.getCurrentUserFromAPI(true).then(
                                        (me: { get: (arg0: string) => any }) => {
                                            UnicornApp.getAppSettings(true).then((settings: any) => {
                                                if (settings.get("buildVersion") !== undefined && props.buildVersion !== undefined && settings.get("buildVersion") !== props.buildVersion) {
                                                    handleHardReload(window.location.href)
                                                }
                                                UnicornApp.globals.authToken = resultData
                                                UnicornApp.previouselySignedInOrOut = true
                                                setTimeout(() => {
                                                    UnicornApp.initSessionAndTokenThread()
                                                }, 5 * 1000)
                                                UnicornApp.startProxyCheckThread()
                                                const client = new ClientJS()
                                                const userBrowserDetails = {
                                                    browserName: client.getBrowser(),
                                                    OSName: client.getOS(),
                                                    userAgent: client.getUserAgent(),
                                                    userId: UnicornApp.getUserId(),
                                                    isMobile: client.isMobile(),
                                                    screenResolution: client.getCurrentResolution(),
                                                    engine: client.getEngine(),
                                                    browserVersion: client.getBrowserVersion(),
                                                    browserMajorVersion:
                                                        client.getBrowserMajorVersion(),
                                                    osVersion: client.getOSVersion(),
                                                    fingerprint: client.getCustomFingerprint(
                                                        client.getUserAgent(),
                                                        client.getBrowser(),
                                                        client.isMobile() + '',
                                                        client.getScreenPrint(),
                                                        client.getEngine(),
                                                        client.getBrowserVersion(),
                                                        client.getBrowserMajorVersion(),
                                                        client.getOS(),
                                                        client.getOSVersion()
                                                    ),
                                                }

                                                setBrowserDetails(userBrowserDetails)
                                                UnicornApp.createBusinessParametersList();
                                                const favWorkspace = me.get('UserFavWorkspace')
                                                if (
                                                    UnicornApp.urlBeforeFailedAuth &&
                                                    UnicornApp.urlBeforeFailedAuth != '#signin'
                                                ) {
                                                    window.location.replace(
                                                        UnicornApp.urlBeforeFailedAuth.substring(0)
                                                    )
                                                    // navigate(
                                                    //     UnicornApp.urlBeforeFailedAuth.substring(
                                                    //         0
                                                    //     ),
                                                    //     {
                                                    //         state: {
                                                    //             /* Pass state here when no longer user Uniorn */
                                                    //         },
                                                    //     }
                                                    // )
                                                } else {
                                                    UnicornApp.redirectToHome('', favWorkspace)
                                                }
                                            })
                                        }
                                    )
                                } else {
                                    setPageError(resultData.data)
                                }
                            }
                        } else {
                            UnicornApp.toastr('error', 'Something went wrong!')
                            setPageError(resultData.data)
                        }
                    }
                }
                setSignInLoading(false)
                setRequestSent(false)
            }
        }      
    return (
        <>
            <div className="row">
                <div className="col-12">
                    <FoundationsForm
                        id="signin_form"
                        submitFunction={submitSignIn}
                        handleSubmit={handleSubmit}
                        classes="pt-0 pb-2"
                    >
                        <div className="row px-2">
                            <div className="col-12" id="status_message">
                                {pageError ? (
                                    <FoundationsAlert
                                        id="signin_status"
                                        type="error"
                                        message={pageError}
                                    ></FoundationsAlert>
                                ) : (
                                    <></>
                                )}
                            </div>
                            <div className="col-12">
                                <h2 className="mt-1 mb-1 text-center">
                                    Sign In To {props.siteName}{' '}
                                </h2>
                            </div>
                            <div className="col-12 mt-2 pr-0">
                                <FoundationsInput
                                    classes="form-group row ml-0"
                                    value={userEmail}
                                    title="User email"
                                    onInput={(e: { target: { value: string } }) => {
                                        setUserEmail(e.target?.value)
                                    }}
                                    id="text_email_address"
                                    name="email_input"
                                    type="text"
                                    containerClasses="col-11 rounded px-0"
                                    maxLength={50}
                                    labelText="Your Email"
                                    labelClasses="col-12 px-0 signin_form_label"
                                    errorClasses="offset-2 col-10 text-left"
                                    tooltipClasses="col-1 pl-2 home-info-icon text-right mt-1 tooltip-icons"
                                    toolTipText="Email should be of the format: name@company.domain"
                                    customStyle={{
                                        marginRight: '-1rem',
                                    }}
                                    registerFunction={register}
                                    registerName="EmailLogin"
                                    registerRules={FormValidation.email}
                                    error={errors.EmailLogin?.message}
                                ></FoundationsInput>
                            </div>
                            <div className="col-12 mt-3 pr-0">
                                <FoundationsInput
                                    classes="form-group row ml-0 mb-3"
                                    value={userPassword}
                                    title="User password"
                                    onInput={(e: { target: { value: string } }) => {
                                        setUserPassword(e.target?.value)
                                    }}
                                    id="text_password"
                                    name="password_input"
                                    type="password"
                                    containerClasses="col-11 rounded px-0"
                                    labelText="Your Password"
                                    maxLength={24}
                                    errorClasses="offset-2 col-10 text-left"
                                    labelClasses="col-12 px-0 signin_form_label"
                                    tooltipClasses="col-1 pl-2 home-info-icon text-right mt-1 tooltip-icons"
                                    toolTipText="Password: &#013;Must be at least 8 letters.&#013;Must have at least one uppercase letter.&#013;Must have at least one lowercase letter.&#013;Must have at least one number.&#013;Must have at least one special character from ~!@#$%^&amp;*(),.+;:?/"
                                    customStyle={{
                                        marginRight: '-1rem',
                                    }}
                                    registerFunction={register}
                                    registerName="PasswordLogin"
                                    registerRules={FormValidation.loginPassword}
                                    error={errors.PasswordLogin?.message}
                                ></FoundationsInput>
                            </div>
                        </div>
                        <div className="row my-1">
                            <FoundationsButton
                                classes="col-12 text-center"
                                type="submit"
                                id="sign_button_el"
                                buttonClasses="app-button w-90 mt-2 mb-3 signin_button"
                                isLoading={signInLoading}
                                loaderClasses="app-account-loading w-90 d-block"
                                disabled={requestSent}
                            >
                                Sign In
                            </FoundationsButton>
                            {props.pivEnabled ? (
    <>
                            <FoundationsButton
                            type="button"
                            classes="col-12 text-center"
                            buttonClasses="app-button w-90 mt-2 mb-3 signin_button"
                            isLoading={signInLoading}
                            id="piv_sign_button_el"
                            onClick={handlePivSignIn}
                            disabled={requestSent}
                            >
    Sign In with PIV
            </FoundationsButton>
            </>
            ) : (
                                <></>
                            )}
                            {props.ssoEnabled ? (
                                <>
                                    <div
                                        className="col-12 text-center mx-auto my-2"
                                        style={{
                                            borderBottom: '1px solid #b6b6b6',
                                            lineHeight: '0.1em',
                                            maxWidth: '80%',
                                            fontSize: '16px',
                                        }}
                                    >
                                        <span
                                            style={{
                                                background: '#fff',
                                                padding: '0 10px',
                                                color: '#b6b6b6',
                                            }}
                                        >
                                            {' '}
                                            or{' '}
                                        </span>
                                    </div>
                                    <FoundationsButton
                                        classes="col-12 text-center"
                                        type="button"
                                        data-id="sso_sign_button_el"
                                        id="sso_sign_button_btn"
                                        buttonClasses="app-button w-90 mt-3 mb-3 signin_button"
                                        isLoading={openIdLoading}
                                        loaderClasses="app-account-loading w-90 d-block"
                                        onClick={onClickSSOSigninButton}
                                        disabled={requestSent}
                                    >
                                        OpenID Sign In
                                    </FoundationsButton>
                                </>
                            ) : (
                                <></>
                            )}
                        </div>

                        <div className="col-12 mt-2 text-left px-0">
                            <div className="row m-0">
                                <div className="col-7 col-sm-7 col-md-7 p-0">
                                    <a
                                        href="#register"
                                        id="ctl00_site_master_main_container_link_first_time_user"
                                        className="signin-link"
                                    >
                                        Don't have an account?
                                    </a>
                                </div>
                                <div className="col-5 col-sm-5 col-md-5 p-0 text-right">
                                    <a
                                        href="#forgot-password"
                                        id="ctl00_site_master_main_container_link_reset_password"
                                        className="signin-link"
                                    >
                                        Forgot Password?
                                    </a>
                                </div>
                            </div>
                        </div>
                    </FoundationsForm>
                </div>
            </div>
        </>
    )
}
